// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/ContextMenuTextAlignRow/TextAlignButton/index.tsx
import { Button } from '@modusign/design-system';
import { TextAlign } from '@modusign/react-signing/types';
import { useMemo } from 'react';

import TextAlignCenterIcon from '@app/components/ContextMenuTextAlignRow/TextAlignButton/TextAlignCenterIcon';
import TextAlignLeftIcon from '@app/components/ContextMenuTextAlignRow/TextAlignButton/TextAlignLeftIcon';
import TextAlignRightIcon from '@app/components/ContextMenuTextAlignRow/TextAlignButton/TextAlignRightIcon';

interface TextAlignButtonProps {
  selected: boolean;
  textAlign: TextAlign;
  onClick: (textAlign: TextAlign) => void;
}

const defaultProps = {
  selected: false,
  onClick(_textAlign: TextAlign) {},
};

function TextAlignButton({ selected, textAlign, onClick }: TextAlignButtonProps) {
  const iconElement = useMemo(() => {
    if (textAlign === 'CENTER') {
      return <TextAlignCenterIcon />;
    }
    if (textAlign === 'RIGHT') {
      return <TextAlignRightIcon />;
    }
    return <TextAlignLeftIcon />;
  }, [textAlign]);

  return (
    <Button
      aria-label={`text align ${textAlign.toLowerCase()}`}
      height={24}
      p={0}
      sx={{
        backgroundColor: selected ? 'buttonBackgroundNeutralDark' : 'buttonBackgroundNeutralBase',
        border: 'none',
        boxShadow: 'none',
        cursor: selected ? 'default' : 'pointer',
        '&:focus': {
          border: '2px solid',
          borderColor: 'pureBlue800',
          borderRadius: '4px',
        },
        '&:hover': {
          backgroundColor: selected
            ? 'buttonBackgroundNeutralDark'
            : 'buttonBackgroundNeutralSlightlyDark',
        },
      }}
      width={24}
      onClick={() => onClick(textAlign)}
    >
      {iconElement}
    </Button>
  );
}

TextAlignButton.defaultProps = defaultProps;

export default TextAlignButton;
